import { InjectionToken } from '@angular/core';

/**
 * Puerto de autenticación (FE-85, revisado en FE-86: el backend es el cliente de Entra ID,
 * así que la consola nunca ve un token). `SimuladaAuth` no hace nada (comportamiento previo);
 * `SesionCookieAuth` solo navega hacia el login de la API y cierra la sesión por cookie.
 */
export interface AuthPort {
  /** Navegación completa del navegador hacia `{API}/v1/auth/login`; `returnTo` debe ser una ruta relativa propia. */
  iniciar(returnTo?: string): void;
  cerrarSesion(): Promise<void>;
}

export const AUTH_PORT = new InjectionToken<AuthPort>('AUTH_PORT');
